export default {
  // Header
  "title": "随机宝可梦生成器",
  "subtitle": "根据您的偏好生成随机宝可梦",
  "home": "首页",
  "whichPokemonAmI": "我是哪个宝可梦？",
  
  // Filters
  "filterTitle": "筛选选项",
  "generateButton": "生成宝可梦",
  "generating": "生成中...",
  "numberOfPokemon": "宝可梦数量",
  "type": "属性",
  "generation": "世代",
  "minimumRarity": "最低稀有度",
  "anyType": "任意属性",
  "anyGeneration": "任意世代",
  "anyRarity": "任意稀有度",
  "countingPokemon": "正在统计匹配的宝可梦...",
  "matchingPokemonCount": "找到 {{count}} 只匹配的宝可梦",
  "noPokemonToDisplay": "没有宝可梦可显示。请生成一些宝可梦！",
  
  // Pokemon Types
  "normal": "一般",
  "fire": "火",
  "water": "水",
  "electric": "电",
  "grass": "草",
  "ice": "冰",
  "fighting": "格斗",
  "poison": "毒",
  "ground": "地面",
  "flying": "飞行",
  "psychic": "超能力",
  "bug": "虫",
  "rock": "岩石",
  "ghost": "幽灵",
  "dragon": "龙",
  "dark": "恶",
  "steel": "钢",
  "fairy": "妖精",
  
  // Generations
  "Generation I": "第一世代",
  "Generation II": "第二世代",
  "Generation III": "第三世代",
  "Generation IV": "第四世代",
  "Generation V": "第五世代",
  "Generation VI": "第六世代",
  "Generation VII": "第七世代",
  "Generation VIII": "第八世代",
  "Generation IX": "第九世代",
  
  // Evolution Stage
  "evolutionStage": "进化阶段",
  "evolutionStageAll": "所有阶段",
  "evolutionStageFullyEvolved": "完全进化",
  "evolutionStageNotFullyEvolved": "未完全进化",
  
  // About Section
  "aboutTitle": "关于随机宝可梦生成器",
  
  // Section titles
  "introTitle": "简介",
  "howToUseTitle": "使用说明",
  "benefitsTitle": "优点",
  "historyTitle": "历史",
  "popularPokemonTitle": "热门宝可梦",
  "popularGamesTitle": "热门游戏",
  "tradingContestsTitle": "交换与竞赛",
  "faqTitle": "常见问题",
  "conclusionTitle": "结语",
  
  // Footer
  "copyright": "© 2025 宝可梦随机生成器。保留所有权利。",
  "trademark": "宝可梦、Pokémon和所有相关名称是任天堂的商标。",
  "linksTitle": "有用链接",
  "aboutUs": "关于我们",
  "contactUs": "联系我们",
  "privacyPolicy": "隐私政策",
  
  // Which Pokemon Am I Feature
  "enterHeightWeight": "输入您的身高和体重 — 看看哪个宝可梦与您匹配！",
  "whichPokemonMatchesSize": "哪个宝可梦符合您的体型？",
  "youAreMostLike": "您最像",
  "madeBy": "创建者：",
  "enterDetails": "输入您的详细信息",
  "nameLabel": "姓名",
  "namePlaceholder": "输入您的姓名",
  "heightLabel": "身高",
  "weightLabel": "体重",
  "findMyPokemon": "找到我的宝可梦",
  "finding": "查找中...",
  "nameRequired": "姓名是必填项",
  "heightValid": "请输入有效的身高（1-300厘米）",
  "weightValid": "请输入有效的体重（1-500公斤）",
  "errorFinding": "查找宝可梦匹配时出错",
  "matchResult": "{{name}}的宝可梦是...",
  "similarityScore": "相似度得分",
  "downloadImage": "下载图片",
  "downloadStarted": "正在准备您的图片...",
  "downloadComplete": "图片下载成功！",
  "shareText": "我发现我是{{pokemon}}！来找出你匹配的宝可梦吧！",
  "tryAgain": "再试一次",
  
  // Which Pokemon Am I Content Sections
  "aboutTool": "关于这个工具",
  "howToUse": "使用方法",
  "benefits": "好处",
  "faq": "常见问题",
  "conclusion": "总结",

  // About Us Page
  "aboutUsTitle": "关于我们",
  "aboutUsWhoWeAre": "我们是谁",
  "aboutUsWhoWeAreContent1": "欢迎来到随机宝可梦生成器，这是一款由热爱宝可梦的粉丝创建的工具。我们的旅程始于2023年，当时一群热爱编程和宝可梦的开发者决定为社区创建一个有用的工具。",
  "aboutUsWhoWeAreContent2": "我们的团队由开发者、设计师和内容创作者组成，他们共同努力为世界各地的宝可梦粉丝提供最好的体验。",
  "aboutUsOurMission": "我们的使命",
  "aboutUsOurMissionContent1": "我们的目标是让宝可梦的世界对每个人都更加开放和有趣。我们的工具旨在帮助训练师发现新的宝可梦，创建平衡的队伍，并找到他们完美的宝可梦搭配。",
  "aboutUsOurMissionContent2": "我们致力于提供用户友好、准确且有趣的体验，尊重宝可梦系列的同时为社区增添价值。",
  "aboutUsOurTeam": "我们的团队",
  "aboutUsOurTeamContent1": "我们的多元化团队汇集了网站开发、宝可梦知识、用户体验设计和社区管理方面的专业知识。我们因对宝可梦的热爱以及对创造高质量工具的承诺而团结在一起。",
  "aboutUsOurTeamContent2": "每位团队成员都贡献了他们独特的技能和观点，使随机宝可梦生成器成为最好的工具。",
  "aboutUsJoinUs": "加入我们",
  "aboutUsJoinUsContent": "我们一直在寻找有热情的人加入我们的社区。无论你是开发者、设计师、宝可梦专家还是热情的用户，我们都欢迎你的反馈和贡献。",

  // Contact Us Page
  "contactUsTitle": "联系我们",
  "contactUsGetInTouch": "取得联系",
  "contactUsGetInTouchContent": "对随机宝可梦生成器有问题、建议或反馈？我们很乐意听取您的意见！以下是您可以联系我们团队的方式。",
  "contactUsEmail": "电子邮件",
  "contactUsPhone": "电话",
  "contactUsAddress": "地址",
  "contactUsHelpSupport": "帮助与支持",
  "contactUsHelpSupportContent": "需要使用我们的工具的帮助或遇到问题？我们的支持团队随时为您提供帮助。",
  "contactUsFAQ": "常见问题",
  "contactUsFAQContent": "在联系我们之前，请查看我们的常见问题部分，其中涵盖了许多常见问题和解决方案。",
  "contactUsBugReport": "报告错误",
  "contactUsBugReportContent": "如果您发现了错误或技术问题，请通过发送电子邮件告知我们，邮件主题请包含'错误报告'字样。",

  // Privacy Policy Page
  "privacyPolicyTitle": "隐私政策",
  "privacyPolicyIntro": "简介",
  "privacyPolicyIntroContent": "在随机宝可梦生成器，我们尊重您的隐私并致力于保护您的个人数据。本隐私政策解释了我们如何在您使用我们的网站时收集、使用和保护您的信息。",
  "privacyPolicyInformation": "我们收集的信息",
  "privacyPolicyInformationContent": "我们收集最少的信息来提供和改进我们的服务。这可能包括：",
  "privacyPolicyInformationItem1": "使用数据（如访问的页面、在网站上花费的时间和使用的功能）",
  "privacyPolicyInformationItem2": "设备信息（浏览器类型、操作系统和屏幕分辨率）",
  "privacyPolicyInformationItem3": "IP地址和大致位置（仅限国家级别）",
  "privacyPolicyCookies": "Cookie和类似技术",
  "privacyPolicyCookiesContent": "我们使用Cookie来增强您在我们网站上的体验。这些小型文本文件使我们能够记住您的偏好并分析我们网站的使用情况。您可以通过浏览器设置控制Cookie。",
  "privacyPolicyThirdParty": "第三方服务",
  "privacyPolicyThirdPartyContent": "我们的网站可能使用第三方服务，如分析提供商和内容交付网络。这些服务可能会收集有关您使用我们网站的信息。我们确保所有第三方都尊重您的隐私并适当处理数据。",
  "privacyPolicySecurity": "数据安全",
  "privacyPolicySecurityContent": "我们实施适当的安全措施，保护您的信息不被未经授权的访问、更改或披露。但是，没有任何互联网传输是100%安全的，因此我们不能保证绝对的安全性。",
  "privacyPolicyChanges": "本政策的变更",
  "privacyPolicyChangesContent": "我们可能会不时更新我们的隐私政策。我们将通过在此页面上发布新的隐私政策并更新'最后更新'日期来通知您任何更改。",
  "privacyPolicyContact": "联系我们",
  "privacyPolicyContactContent": "如果您对本隐私政策有任何问题，请通过我们联系页面上提供的信息联系我们。",
  "privacyPolicyLastUpdated": "最后更新",

  // New Page: Pokemon Randomizer - About Section Titles (Translated to Simplified Chinese)
  "pokemonRandomizerPageAboutTitle": "探索终极宝可梦随机生成器体验",
  "pokemonRandomizer_whatIsItTitle": "宝可梦随机生成器究竟是什么？",
  "pokemonRandomizer_featuresTitle": "我们的宝可梦随机生成器工具的主要特点",
  "pokemonRandomizer_whyUseTitle": "为什么要用宝可梦随机生成器开始冒险？",
  "pokemonRandomizer_gettingStartedTitle": "快速上手：您的首次宝可梦随机生成器之旅",
  "pokemonRandomizer_faqTitle": "宝可梦随机生成器：常见问题解答",

  // New keys for PokemonRandomizerPage.tsx H1 and subtitle (Translated to Simplified Chinese)
  "pokemonRandomizerPageH1": "宝可梦随机化器",
  "pokemonRandomizerPageSubtitle": "使用我们的高级随机化工具创造独特的宝可梦体验。",

  // Sub-Footer
  "subFooterToolsTitle": "工具",
  "subFooterRandomPokemonGeneratorLink": "随机宝可梦生成器",
  "subFooterPokemonRandomizerLink": "宝可梦随机化器",
  "subFooterWhichPokemonAmILink": "我是哪个宝可梦？",

  "subFooterPokemonDatabaseTitle": "宝可梦数据库",
  "subFooterPokedexLink": "宝可梦图鉴 (敬请期待)",
  "subFooterTypeChartsLink": "属性相克表",
  "subFooterMoveListLink": "招式列表 (敬请期待)",

  "subFooterBlogTitle": "博客",
  "subFooterLatestArticlesLink": "最新文章 (敬请期待)",
  "subFooterGuidesTutorialsLink": "指南与教程 (敬请期待)",
  "pokedexEyebrow": "\u5b9d\u53ef\u68a6\u6570\u636e\u5e93",
  "pokedexPageTitle": "\u5b9d\u53ef\u68a6\u56fe\u9274",
  "pokedexPageSubtitle": "\u53ef\u4ee5\u6309\u540d\u79f0\u3001\u7f16\u53f7\u3001\u4e16\u4ee3\u6216\u5c5e\u6027\u5feb\u901f\u67e5\u627e\uff0c\u5e76\u5728\u5f53\u524d\u9875\u76f4\u63a5\u67e5\u770b\u66f4\u5b8c\u6574\u7684\u5b9d\u53ef\u68a6\u8be6\u60c5\u3002",
  "pokedexSearchLabel": "\u641c\u7d22",
  "pokedexSearchPlaceholder": "\u6309\u540d\u79f0\u6216\u56fe\u9274\u7f16\u53f7\u641c\u7d22",
  "pokedexAllGenerations": "\u5168\u90e8\u4e16\u4ee3",
  "pokedexAllTypes": "\u5168\u90e8\u5c5e\u6027",
  "pokedexSortLabel": "\u6392\u5e8f",
  "pokedexSortNumber": "\u56fe\u9274\u7f16\u53f7\u5347\u5e8f",
  "pokedexSortName": "\u540d\u79f0 A-Z",
  "pokedexSortRarity": "\u7a00\u6709\u5ea6\u4ece\u9ad8\u5230\u4f4e",
  "pokedexSortHeight": "\u8eab\u9ad8\u4ece\u9ad8\u5230\u4f4e",
  "pokedexSortWeight": "\u4f53\u91cd\u4ece\u9ad8\u5230\u4f4e",
  "pokedexClearFilters": "\u6e05\u7a7a\u7b5b\u9009",
  "pokedexTotalEntries": "\u5168\u90e8\u6570\u91cf",
  "pokedexFilteredEntries": "\u5339\u914d\u7ed3\u679c",
  "pokedexPageIndicator": "\u9875\u7801",
  "pokedexInspect": "\u67e5\u770b",
  "pokedexShowingResults": "\u5f53\u524d\u663e\u793a {{start}}-{{end}} \uff0c\u5171 {{total}} \u6761",
  "pokedexPrevious": "\u4e0a\u4e00\u9875",
  "pokedexNext": "\u4e0b\u4e00\u9875",
  "pokedexPageStatus": "\u7b2c {{page}} \u9875 / \u5171 {{total}} \u9875",
  "pokedexEmptyTitle": "\u672a\u627e\u5230\u7b26\u5408\u6761\u4ef6\u7684\u5b9d\u53ef\u68a6",
  "pokedexEmptyBody": "\u53ef\u4ee5\u5c1d\u8bd5\u66f4\u6362\u540d\u79f0\u5173\u952e\u5b57\u3001\u4e16\u4ee3\u6216\u5c5e\u6027\u7b5b\u9009\uff0c\u56fe\u9274\u6570\u636e\u4ecd\u7136\u4f1a\u4fdd\u6301\u5b8c\u6574\u3002",
  "pokedexLoadErrorTitle": "\u56fe\u9274\u6570\u636e\u52a0\u8f7d\u5931\u8d25",
  "pokedexLoadErrorBody": "\u672c\u5730\u5b9d\u53ef\u68a6\u6570\u636e\u5e93\u6682\u65f6\u65e0\u6cd5\u8bfb\u53d6\uff0c\u6240\u4ee5\u56fe\u9274\u9875\u65e0\u6cd5\u6e32\u67d3\u3002",
  "pokedexDetailDescription": "\u5b9d\u53ef\u68a6\u8be6\u60c5\u9762\u677f",
  "pokedexDetailError": "\u6682\u65f6\u65e0\u6cd5\u52a0\u8f7d\u8fd9\u53ea\u5b9d\u53ef\u68a6\u7684\u8be6\u7ec6\u4fe1\u606f\u3002",
  "pokedexDetailLoading": "\u6b63\u5728\u52a0\u8f7d\u56fe\u9274\u6761\u76ee...",
  "pokedexOverviewTitle": "\u6982\u89c8",
  "pokedexBaseExperience": "\u57fa\u7840\u7ecf\u9a8c",
  "pokedexAbilitiesTitle": "\u7279\u6027",
  "pokedexStatsTitle": "\u79cd\u65cf\u503c",
  "pokedexMovesTitle": "\u4ee3\u8868\u62db\u5f0f",
  "pokedexMovesLearnset": "\u4e60\u5f97\u7248\u672c",
  "pokedexMovesUnavailable": "\u6682\u65f6\u65e0\u6cd5\u63d0\u4f9b\u8fd9\u4e2a\u6761\u76ee\u7684\u62db\u5f0f\u8be6\u60c5\u3002",
  "pokedexMovesPower": "\u5a01\u529b",
  "pokedexMovesAccuracy": "\u547d\u4e2d",
  "pokedexMovesPP": "PP",
  "pokedexMovesPriority": "\u4f18\u5148\u5ea6",
  "pokedexMovesEffect": "\u6548\u679c",
  "pokedexMovesEffectFallback": "\u5f53\u524d\u8bed\u8a00\u4e0b\u6682\u65e0\u8fd9\u4e2a\u62db\u5f0f\u7684\u6548\u679c\u8bf4\u660e\u3002",
  "pokedexMovesRoutes": "\u4e60\u5f97\u65b9\u5f0f",
  "pokedexMovesLevel": "Lv.",
  "pokedexMoveMethodLevelUp": "\u5347\u7ea7",
  "pokedexVersionGroupScarletViolet": "\u6731\uff0f\u7d2b",
  "pokedexMoveMethodMachine": "\u62db\u5f0f\u673a",
  "pokedexMoveMethodEgg": "\u9057\u4f20",
  "pokedexMoveMethodTutor": "\u5bfc\u5e08",
  "pokedexMoveMethodEvolution": "\u8fdb\u5316",
  "pokedexMoveMethodFormChange": "\u5f62\u6001\u53d8\u5316",
  "pokedexMoveMethodSpecial": "\u7279\u6b8a",
  "pokedexMoveDamagePhysical": "\u7269\u7406",
  "pokedexMoveDamageSpecial": "\u7279\u6b8a",
  "pokedexMoveDamageStatus": "\u53d8\u5316"
};
